angular.module('offlineChecker')
  .factory('loginFactory',loginFactory);

loginFactory.$inject = ['$http','storageFactory','sessionFactory','uiManagerFactory'];
function loginFactory($http, storageFactory, sessionFactory, uiManagerFactory){
  var username = '';
  var password = '';
  var newPin = {
    first: '',
    confirm: '',
    errors: ''
  };
  var loginFactoryVar = {
    username: username,
    password: password,
    newPin: newPin,
    login: login,
    sync: sync,
    syncKnownUser: syncKnownUser,
    getToken: getToken,
    getNewToken: getNewToken
  };

  return loginFactoryVar;

  function login(successFunc, failedFunc){
    $http.post('/login?json', {
      username2: loginFactoryVar.username,
      pswd2: loginFactoryVar.password
    }).then(function(data, status, headers, config){
        if(data.data.success){
          if(typeof successFunc !== 'undefined'){
            successFunc(data, status, headers, config);
          }
        } else {
          if(typeof failedFunc !== 'undefined'){
            failedFunc(data, status, headers, config);
          }
        }
    }, function(data, status, headers, config){
      if(typeof failedFunc !== 'undefined'){
        failedFunc(data, status, headers, config);
      }
    });
  }

  function sync(successFunc, failedFunc){
    $http.post('/offline-checker/sync',{
      'selectedProperty': sessionFactory.selectedProperty
    }).then(function(data, status, headers, config){
      successFunc(data);
    }, function(data, status, headers, config){
      failedFunc(data);
    });
  }

  function syncKnownUser(token, successFunc, failedFunc){
    $http.post('/offline-checker/sync', {
      'x-offline-checker-token': token,
      'selectedProperty': sessionFactory.selectedProperty
    }).then(function(data, status, headers, config){
      if(data.data.token !== token){
        resetUserNoLongerValid();
        return false;
        // user needs to go back to the login page
        // remove known user from list
        // delete all known data
      }
      successFunc(data);
    }, function(data, status, headers, config){
      if(data.status === 401){
        resetUserNoLongerValid();
        return false;
        // user needs to go back to the login page
        // remove known user from list
        // delete all known data
      }
      failedFunc(data);
    });
  }

  function resetUserNoLongerValid(){
    // set error message to show user exactly what has happened....
    sessionFactory.knownUserLoginFailed = 'Your session is no longer valid, please login again';
    // remove known user from list // delete all known data
    storageFactory.savedUser.delete();
    storageFactory.userToken.delete();
    storageFactory.reservations.delete();
    storageFactory.keys.delete();
    storageFactory.properties.delete();
    storageFactory.savedUnitReportGroups.delete();
    storageFactory.lastSynced.delete();
    // stop loader from showing
    uiManagerFactory.loader.isFullScreenLoading = false;
    sessionFactory.currentLogin.pin = '';
    sessionFactory.currentLogin.username = '';
    sessionFactory.currentLogin.user = null;
    sessionFactory.availableUsers = null;
    sessionFactory.currentLogin.user = null;
    // user needs to go back to the login page
    uiManagerFactory.goToPage('/login');
  }

  function getToken(tokenReceived, tokenFailed){
    $http.get('/offline-checker/sync')
      .then(function(data, status, headers, config){
        console.log(data, status, headers, config);
      },function(data, status, headers, config){
        console.log(data, status, headers, config);
    });
  }

  function getNewToken(username){
    $http.get('/offline-checker/sync')
      .then(function(data, status, headers, config){
          //data.token
      },function(data, status, headers, config){

    });
  }
}
